import { useMemo } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useFeatureFlagsContext } from '@storefront/lib-global';

export type KlarnaScriptProps = {
  id: string;
};

export function KlarnaPdpWidgetScript({ id }: KlarnaScriptProps) {
  const { isKlarnaPdpEnabled } = useFeatureFlagsContext();
  const { locale } = useRouter();
  const dataClientId = useMemo(() => {
    switch (locale) {
      case 'en-gb':
        return process.env.NEXT_PUBLIC_KLARNA_DATA_CLIENT_ID_GB;
      case 'en-ie':
        return process.env.NEXT_PUBLIC_KLARNA_DATA_CLIENT_ID_IE;
      case 'en-us':
        return process.env.NEXT_PUBLIC_KLARNA_DATA_CLIENT_ID_US;
      case 'en-ca':
      case 'fr-ca':
        return process.env.NEXT_PUBLIC_KLARNA_DATA_CLIENT_ID_CA;
      default:
        return null;
    }
  }, [locale]);

  if (!isKlarnaPdpEnabled || !locale) return null;
  const dataEnvironment = process.env.NEXT_PUBLIC_KLARNA_WIDGET_ENV;

  return (
    <Script
      id={id}
      async
      data-environment={dataEnvironment}
      src="https://js.klarna.com/web-sdk/v1/klarna.js"
      data-client-id={dataClientId}
    />
  );
}
